import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';



const Input = (props) => {

  return (
        <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id={props.email}
        label={props.label}
        name={props.name}
        autoFocus={props.autoFocus}
        type={props.type}
        autoComplete={props.autoComplete}
        onChange={props.onChange}
        value={props.value}
           />
  );
};

export { Input }